var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.75C39.3164 33.75 46.875 26.1914 46.875 16.875C46.875 7.55859 39.3164 0 30 0C20.6836 0 13.125 7.55859 13.125 16.875C13.125 26.1914 20.6836 33.75 30 33.75ZM45 37.5H38.543C35.9414 38.6953 33.0469 39.375 30 39.375C26.9531 39.375 24.0703 38.6953 21.457 37.5H15C6.71484 37.5 0 44.2148 0 52.5V54.375C0 57.4805 2.51953 60 5.625 60H54.375C57.4805 60 60 57.4805 60 54.375V52.5C60 44.2148 53.2852 37.5 45 37.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ed8017dc4205b1fb53b42be1ed45d8bc.svg";
export { ForwardRef as ReactComponent };